import Header from "./components/header/header.js";
import { Fragment } from "react";
import HeroSection from "./components/hero-section/heroSection1";
import Feature from "./components/features/feature";
import Download from "./components/call-to-action/download.js";
import Footer from "./components/footer/footer.js";
import Compatibility from "./components/compatibility/compatibility.js";
import Instructions from "./components/instructions/instructions.js";

function App() {
  return (
    <Fragment>
      <Header />
      <div className="main">
        <HeroSection />
        <Feature />
        <Download />
        <Compatibility />
        {/* <Instructions/> */}
      </div>
      <Footer />
    </Fragment>
  );
}

export default App;
